export default __webpack_public_path__ + "static/media/03.fe0f3f0a.png";